const Logo = ({ small }: { small?: boolean }) =>
  small ? (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.0336 1.75024C11.6792 1.75024 0 13.4311 0 27.7889C0 42.1453 11.6792 53.8261 26.0336 53.8261C40.4433 53.8261 52.1668 42.1453 52.1668 27.7889C52.1668 13.4311 40.4433 1.75024 26.0336 1.75024ZM26.0336 45.3789C16.7133 45.3789 8.83966 37.324 8.83966 27.7889C8.83966 18.2539 16.7133 10.1989 26.0336 10.1989C35.5152 10.1989 43.2276 18.0895 43.2276 27.7889C43.2276 37.4869 35.5152 45.3789 26.0336 45.3789Z"
        fill="white"
      />
      <path
        d="M48.9971 29.4917C35.1424 21.1078 24.1462 28.7848 25.8742 32.9341C37.3495 27.0012 40.333 38.9492 53.8715 39.4015C65.9903 38.9666 70.2986 31.998 69.984 25.8342C69.739 21.0382 64.0914 38.6266 48.9971 29.4917Z"
        fill="#FFCE6C"
      />
    </svg>
  ) : (
    <svg
      width="70"
      height="53"
      viewBox="0 0 70 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.0336 1.75024C11.6792 1.75024 0 13.4311 0 27.7889C0 42.1453 11.6792 53.8261 26.0336 53.8261C40.4433 53.8261 52.1668 42.1453 52.1668 27.7889C52.1668 13.4311 40.4433 1.75024 26.0336 1.75024ZM26.0336 45.3789C16.7133 45.3789 8.83966 37.324 8.83966 27.7889C8.83966 18.2539 16.7133 10.1989 26.0336 10.1989C35.5152 10.1989 43.2276 18.0895 43.2276 27.7889C43.2276 37.4869 35.5152 45.3789 26.0336 45.3789Z"
        fill="white"
      />
      <path
        d="M48.9971 29.4917C35.1424 21.1078 24.1462 28.7848 25.8742 32.9341C37.3495 27.0012 40.333 38.9492 53.8715 39.4015C65.9903 38.9666 70.2986 31.998 69.984 25.8342C69.739 21.0382 64.0914 38.6266 48.9971 29.4917Z"
        fill="#FFCE6C"
      />
    </svg>
  );
export default Logo;
